import React, { useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import AttributeCategoryFormComponent from "./component";

const AttributeCategoryFormContainer = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { categoryId, subCategoryId } = useParams();
  
  const categoryName = location.state?.categoryName || "Category";
  const subCategoryName = location.state?.subCategoryName || "";
  const ownerType = location.state?.ownerType || "CATEGORY";
  
  const ownerId = subCategoryId || categoryId || location.state?.ownerId || location.state?.categoryId;
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleCreateCategory = (data) => {
    if (!ownerId) {
      toastr.error("Error", "Owner ID is missing. Please go back and try again.");
      return;
    }
    
    setIsSubmitting(true);
    
    // Transform attributes to API format
    const attributeList = data.attributes.map(attr => {
      const attributeDto = {
        key: attr.name,
        dataType: mapValueTypeToDataType(attr.valueType),
        isRequired: attr.required === "Yes",
      };
      
      // ✅ For Boolean type - add isBoolean field
      if (attr.valueType === "Boolean" && attr.booleanValue) {
        attributeDto.isBoolean = attr.booleanValue; // "Yes" or "No"
      }
      
      // ✅ ONLY for List/DROPDOWN type, add dropdownOptions
      if (attr.valueType === "List" && attr.listValues) {
        attributeDto.dropdownOptions = attr.listValues.split(',').map(v => v.trim());
      }
      
      // ✅ Unit - ONLY for List type AND when Unit Type is "Yes"
      if (attr.valueType === "List") {
        if (attr.unitType === "Yes") {
          attributeDto.unit = "Yes";
          
          // ✅ Send unitValues as array when unitType is Yes AND unitValues is not empty
          if (attr.unitValues && attr.unitValues.trim()) {
            attributeDto.unitValues = attr.unitValues.split(',').map(v => v.trim()).filter(v => v);
          } else {
            attributeDto.unitValues = [];
          }
        } else {
          attributeDto.unit = "No";
          attributeDto.unitValues = [];
        }
      } else {
        // For non-List types, unit and unitValues should be null or not sent
        attributeDto.unit = null;
        // Don't send unitValues for non-List types
      }
      
      return attributeDto;
    });
    
    const payload = {
      ownerType: ownerType,
      ownerId: parseInt(ownerId),
      attributeHeadings: [
        {
          heading: data.name,
          productAttributeDtoList: attributeList
        }
      ]
    };
    
    console.log("📤 Sending payload:", JSON.stringify(payload, null, 2));
    
    props.getDataFromAPI(
      "/partner/api/v1/attributes",
      "POST",
      payload,
      (response) => {
        setIsSubmitting(false);
        setSuccessMessage(`"${data.name}" added successfully!`);
        setShowSuccessPopup(true);
      },
      (err) => {
        setIsSubmitting(false);
        const errorMsg = err?.response?.message || err?.message || "Failed to create attribute category";
        toastr.error("Error", errorMsg);
        console.error("API Error:", err);
      }
    );
  };
  
  const handleCloseSuccessPopup = () => {
    setShowSuccessPopup(false);
    navigate(-1);
  };
  
  const mapValueTypeToDataType = (valueType) => {
    switch (valueType) {
      case "Text": return "STRING";
      case "Number": return "NUMBER";
      case "List": return "DROPDOWN";
      case "Boolean": return "BOOLEAN";
      default: return "STRING";
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <AttributeCategoryFormComponent
      mode="create"
      categoryName={categoryName}
      subCategoryName={subCategoryName}
      isSubmitting={isSubmitting}
      onCreateCategory={handleCreateCategory}
      onBack={handleBack}
      showSuccessPopup={showSuccessPopup}
      successMessage={successMessage}
      onCloseSuccessPopup={handleCloseSuccessPopup}
    />
  );
};

const mapDispatchToProps = {
  getDataFromAPI: getDataFromAPI
};

export default connect(null, mapDispatchToProps)(AttributeCategoryFormContainer);